export default __webpack_public_path__ + "static/media/contact.02d5111d.jpg";